module.exports = __webpack_public_path__ + "static/media/ehealth_bpbg_banner_mobile.5fa86475.jpg";